import {
  createRouter,
  createRoute,
  createRootRoute,
  redirect,
} from '@tanstack/react-router'
import { AppShell } from './components/AppShell'
import { Login } from './pages/Login'
import { useAuth } from './store/auth'
import { Dashboard } from './pages/Dashboard'
import { Pedidos } from './pages/Pedidos'
import { PedidoDetalle } from './pages/PedidoDetalle'
import { PedidoNuevo } from './pages/PedidoNuevo'
import { Productos } from './pages/Productos'
import { ProductoDetalle } from './pages/ProductoDetalle'
import { ProductoEditar } from './pages/ProductoEditar'
import { ProductoNuevo } from './pages/ProductoNuevo'
import { Categorias } from './pages/Categorias'
import { CategoriaForm } from './pages/CategoriaForm'
import { Marcas } from './pages/Marcas'
import { MarcaForm } from './pages/MarcaForm'
import { Clientes } from './pages/Clientes'
import { ClienteDetalle } from './pages/ClienteDetalle'
import { ClienteFormPage as ClienteForm } from './pages/ClienteForm'
import { Cupones } from './pages/Cupones'
import { CuponForm } from './pages/CuponForm'
import { Envios } from './pages/Envios'
import { EnvioFormPage as EnvioForm } from './pages/EnvioForm'
import { Blog } from './pages/Blog'
import { BlogPostForm } from './pages/BlogPostForm'
import { Reportes } from './pages/Reportes'
import { Configuracion } from './pages/Configuracion'
import { Sucursales } from './pages/Sucursales'
import { Textos } from './pages/Textos'
import { Branding } from './pages/Branding'
import { MenuPage } from './pages/Menu'
import { Beneficios } from './pages/Beneficios'
import { SeccionesHome } from './pages/SeccionesHome'
import { Paginas } from './pages/Paginas'
import { PaginaForm } from './pages/PaginaForm'
import { ProductosBulkUpload } from './pages/ProductosBulkUpload'
import { Banners } from './pages/Banners'
import { BannerFormPage } from './pages/BannerForm'
import { Slider } from './pages/Slider'
import { Reviews } from './pages/Reviews'
import { Llantas } from './pages/Llantas'
import { LlantaForm } from './pages/LlantaForm'
import { LlantasBulkUpload } from './pages/LlantasBulkUpload'
import { MarcasLlantas } from './pages/MarcasLlantas'
import { ProveedoresLlantas } from './pages/ProveedoresLlantas'
import { PromoBar } from './pages/PromoBar'
import { FAQ } from './pages/FAQ'
import { PaymentMethods } from './routes/payment-methods'
import { ProductosDuplicados } from './pages/ProductosDuplicados'
import { Admins } from './pages/Admins'
import { MiCuenta } from './pages/MiCuenta'
import { ReportesCalidad } from './pages/ReportesCalidad'
import { ImportarDatos } from './pages/ImportarDatos'
import { BancoImagenes } from './pages/BancoImagenes'
import { SeoTools } from './pages/SeoTools'
import { LibroVentas } from './pages/LibroVentas'
import { Feeds } from './pages/Feeds'
import { Newsletter } from './pages/Newsletter'
import { Backup } from './pages/Backup'
import { Logs } from './pages/Logs'
import { EmailTemplates } from './pages/EmailTemplates'
import { AplazoSettlement } from './pages/AplazoSettlement'
import { Buscador } from './pages/Buscador'
import { Proveedores } from './pages/Proveedores'
import { ProductosImagenesMasivas } from './pages/ProductosImagenesMasivas'
import { Devoluciones } from './pages/Devoluciones'
import { CarritosAbandonados } from './pages/CarritosAbandonados'
import { PickingList } from './pages/PickingList'
import { AnalyticsAvanzado } from './pages/AnalyticsAvanzado'
import { WishlistAnalytics } from './pages/WishlistAnalytics'
import { AuditLog } from './pages/AuditLog'
import { Roles } from './pages/Roles'
import { RolEditor } from './pages/RolEditor'
import { NotifChannels } from './pages/NotifChannels'
import { ReporteCierre } from './pages/ReporteCierre'
import { Refunds } from './pages/Refunds'
import { Recomendados } from './pages/Recomendados'
import { Testimonios } from './pages/Testimonios'
import { Footer } from './pages/Footer'
import { Facturas } from './pages/Facturas'
import { ConfiguracionFacturacion } from './pages/ConfiguracionFacturacion'
import { AutorizarEnvios } from './pages/AutorizarEnvios'

const rootRoute = createRootRoute()

const loginRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: '/login',
  component: Login,
})

const shellRoute = createRoute({
  getParentRoute: () => rootRoute,
  id: 'shell',
  beforeLoad: ({ location }) => {
    const user = useAuth.getState().user
    if (!user) {
      throw redirect({
        to: '/login',
        search: { redirect: location.href },
      })
    }
    if (user.role !== 'admin' && user.role !== 'operator') {
      throw redirect({ to: '/login' })
    }
  },
  component: AppShell,
})

// Dashboard
const dashboardRoute = createRoute({ getParentRoute: () => shellRoute, path: '/', component: Dashboard })

// Pedidos
const pedidosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/pedidos', component: Pedidos })
const pedidoNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/pedidos/nuevo', component: PedidoNuevo })
const pedidoDetalleRoute = createRoute({ getParentRoute: () => shellRoute, path: '/pedidos/$id', component: PedidoDetalle })

// Productos
const productosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos', component: Productos })
const productoNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos/nuevo', component: ProductoNuevo })
const productosBulkUploadRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos/carga-masiva', component: ProductosBulkUpload })
const productoDetalleRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos/$id', component: ProductoDetalle })
const productoEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos/$id/editar', component: ProductoEditar })

// Llantas
const llantasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/llantas', component: Llantas })
const llantaNuevaRoute = createRoute({ getParentRoute: () => shellRoute, path: '/llantas/nueva', component: () => <LlantaForm mode="create" /> })
const llantasBulkRoute = createRoute({ getParentRoute: () => shellRoute, path: '/llantas/carga-masiva', component: LlantasBulkUpload })
const llantaEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/llantas/$id', component: () => <LlantaForm mode="edit" /> })
const marcasLlantasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/llantas/marcas', component: MarcasLlantas })
const proveedoresLlantasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/llantas/proveedores', component: ProveedoresLlantas })

// Categorías
const categoriasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/categorias', component: Categorias })
const categoriaNuevaRoute = createRoute({ getParentRoute: () => shellRoute, path: '/categorias/nueva', component: CategoriaForm })
const categoriaEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/categorias/$id', component: CategoriaForm })

// Marcas
const marcasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/marcas', component: Marcas })
const marcaNuevaRoute = createRoute({ getParentRoute: () => shellRoute, path: '/marcas/nueva', component: MarcaForm })
const marcaEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/marcas/$id', component: MarcaForm })

// Clientes
const clientesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/clientes', component: Clientes })
const clienteDetalleRoute = createRoute({ getParentRoute: () => shellRoute, path: '/clientes/$id', component: ClienteDetalle })
const clienteEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/clientes/$id/editar', component: ClienteForm })

// Cupones
const cuponesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/cupones', component: Cupones })
const cuponNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/cupones/nuevo', component: CuponForm })
const cuponEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/cupones/$id', component: CuponForm })

// Envíos — la página nueva (settings planos) reemplaza las zonas detalladas.
// Rutas viejas /envios/nuevo y /envios/$id quedan como aliases que redirigen.
const autorizarEnviosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/autorizar-envios', component: AutorizarEnvios })
const enviosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/envios', component: Envios })
const envioNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/envios/nuevo', component: Envios })
const envioEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/envios/$id', component: Envios })

// Blog
const blogRoute = createRoute({ getParentRoute: () => shellRoute, path: '/blog', component: Blog })
const blogNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/blog/nuevo', component: () => <BlogPostForm mode="create" /> })
const blogEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/blog/$id', component: () => <BlogPostForm mode="edit" /> })

// Reportes + Configuración + extras
const reportesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/reportes', component: Reportes })
const configRoute = createRoute({ getParentRoute: () => shellRoute, path: '/configuracion', component: Configuracion })
const sucursalesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/sucursales', component: Sucursales })
const textosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/textos', component: Textos })
const brandingRoute = createRoute({ getParentRoute: () => shellRoute, path: '/branding', component: Branding })
const menuRoute = createRoute({ getParentRoute: () => shellRoute, path: '/menu', component: MenuPage })
const beneficiosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/beneficios', component: Beneficios })
const seccionesHomeRoute = createRoute({ getParentRoute: () => shellRoute, path: '/secciones-home', component: SeccionesHome })

// Paginas
const paginasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/paginas', component: Paginas })
const paginaNuevaRoute = createRoute({ getParentRoute: () => shellRoute, path: '/paginas/nueva', component: () => <PaginaForm mode="create" /> })
const paginaEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/paginas/$id', component: () => <PaginaForm mode="edit" /> })

// Banners
const bannersRoute = createRoute({ getParentRoute: () => shellRoute, path: '/banners', component: Banners })
const bannerNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/banners/nuevo', component: () => <BannerFormPage mode="create" /> })
const bannerEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/banners/$id', component: () => <BannerFormPage mode="edit" /> })

// Slider
const sliderRoute = createRoute({ getParentRoute: () => shellRoute, path: '/slider', component: Slider })
const sliderNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/slider/nuevo', component: Slider })
const sliderEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/slider/$id', component: Slider })

// Reviews
const reviewsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/reviews', component: Reviews })

// Promo bar + FAQ
const promoBarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/promo-bar', component: PromoBar })
const promoBarNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/promo-bar/nuevo', component: PromoBar })
const promoBarEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/promo-bar/$id', component: PromoBar })
const faqRoute = createRoute({ getParentRoute: () => shellRoute, path: '/faq', component: FAQ })
const faqNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/faq/nuevo', component: FAQ })
const faqEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/faq/$id', component: FAQ })

// Métodos de pago
const paymentMethodsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/payment-methods', component: PaymentMethods })

// Nuevos módulos migrados de v1
const productosDuplicadosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos/duplicados', component: ProductosDuplicados })
const adminsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/admins', component: Admins })
const miCuentaRoute = createRoute({ getParentRoute: () => shellRoute, path: '/mi-cuenta', component: MiCuenta })
const reportesCalidadRoute = createRoute({ getParentRoute: () => shellRoute, path: '/reportes-calidad', component: ReportesCalidad })
const importarDatosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/importar-datos', component: ImportarDatos })
const bancoImagenesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/banco-imagenes', component: BancoImagenes })
const seoToolsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/seo-tools', component: SeoTools })
const libroVentasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/libro-ventas', component: LibroVentas })
const feedsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/feeds', component: Feeds })
const newsletterRoute = createRoute({ getParentRoute: () => shellRoute, path: '/newsletter', component: Newsletter })
const backupRoute = createRoute({ getParentRoute: () => shellRoute, path: '/sistema/backup', component: Backup })
const logsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/logs', component: Logs })
const emailTemplatesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/email-templates', component: EmailTemplates })
const aplazoSettlementRoute = createRoute({ getParentRoute: () => shellRoute, path: '/aplazo-settlement', component: AplazoSettlement })
const buscadorRoute = createRoute({ getParentRoute: () => shellRoute, path: '/buscador', component: Buscador })
const proveedoresRoute = createRoute({ getParentRoute: () => shellRoute, path: '/proveedores', component: Proveedores })
const productosImagenesMasivasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/productos/imagenes-masivas', component: ProductosImagenesMasivas })
const devolucionesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/devoluciones', component: Devoluciones })
const carritosAbandonadosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/carritos-abandonados', component: CarritosAbandonados })
const pickingListRoute = createRoute({ getParentRoute: () => shellRoute, path: '/picking-list', component: PickingList })
const analyticsAvanzadoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/analytics-avanzado', component: AnalyticsAvanzado })
const wishlistAnalyticsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/wishlist-analytics', component: WishlistAnalytics })

// Workflow 7: módulos admin nuevos
const auditLogRoute = createRoute({ getParentRoute: () => shellRoute, path: '/audit-log', component: AuditLog })
const rolesRoute = createRoute({ getParentRoute: () => shellRoute, path: '/roles', component: Roles })
const rolNuevoRoute = createRoute({ getParentRoute: () => shellRoute, path: '/roles/nuevo', component: RolEditor })
const rolEditarRoute = createRoute({ getParentRoute: () => shellRoute, path: '/roles/$id', component: RolEditor })
const notifChannelsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/notif-channels', component: NotifChannels })
const reportesCierreRoute = createRoute({ getParentRoute: () => shellRoute, path: '/reportes-cierre', component: ReporteCierre })
const refundsRoute = createRoute({ getParentRoute: () => shellRoute, path: '/refunds', component: Refunds })
const recomendadosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/recomendados', component: Recomendados })
const testimoniosRoute = createRoute({ getParentRoute: () => shellRoute, path: '/testimonios', component: Testimonios })
const footerRoute = createRoute({ getParentRoute: () => shellRoute, path: '/footer', component: Footer })

// Facturación CFDI 4.0
const facturasRoute = createRoute({ getParentRoute: () => shellRoute, path: '/facturas', component: Facturas })
const configFacturacionRoute = createRoute({ getParentRoute: () => shellRoute, path: '/facturacion', component: ConfiguracionFacturacion })

const routeTree = rootRoute.addChildren([
  loginRoute,
  shellRoute.addChildren([
    dashboardRoute,
    pedidosRoute, pedidoNuevoRoute, pedidoDetalleRoute,
    productosRoute, productoNuevoRoute, productosBulkUploadRoute, productoDetalleRoute, productoEditarRoute,
    llantasRoute, llantaNuevaRoute, llantasBulkRoute, llantaEditarRoute,
    marcasLlantasRoute, proveedoresLlantasRoute,
    categoriasRoute, categoriaNuevaRoute, categoriaEditarRoute,
    marcasRoute, marcaNuevaRoute, marcaEditarRoute,
    clientesRoute, clienteDetalleRoute, clienteEditarRoute,
    cuponesRoute, cuponNuevoRoute, cuponEditarRoute,
    autorizarEnviosRoute,
    enviosRoute, envioNuevoRoute, envioEditarRoute,
    blogRoute, blogNuevoRoute, blogEditarRoute,
    reportesRoute,
    configRoute,
    sucursalesRoute,
    textosRoute,
    brandingRoute,
    menuRoute,
    beneficiosRoute,
    seccionesHomeRoute,
    paginasRoute, paginaNuevaRoute, paginaEditarRoute,
    bannersRoute, bannerNuevoRoute, bannerEditarRoute,
    sliderRoute, sliderNuevoRoute, sliderEditarRoute,
    reviewsRoute,
    promoBarRoute, promoBarNuevoRoute, promoBarEditarRoute,
    faqRoute, faqNuevoRoute, faqEditarRoute,
    paymentMethodsRoute,
    productosDuplicadosRoute,
    adminsRoute,
    miCuentaRoute,
    reportesCalidadRoute,
    importarDatosRoute,
    bancoImagenesRoute,
    seoToolsRoute,
    libroVentasRoute,
    feedsRoute,
    newsletterRoute,
    backupRoute,
    logsRoute,
    emailTemplatesRoute,
    aplazoSettlementRoute,
    buscadorRoute,
    proveedoresRoute,
    productosImagenesMasivasRoute,
    devolucionesRoute,
    carritosAbandonadosRoute,
    pickingListRoute,
    analyticsAvanzadoRoute,
    wishlistAnalyticsRoute,
    auditLogRoute,
    rolesRoute, rolNuevoRoute, rolEditarRoute,
    notifChannelsRoute,
    reportesCierreRoute,
    refundsRoute,
    recomendadosRoute,
    testimoniosRoute,
    footerRoute,
    facturasRoute, configFacturacionRoute,
  ]),
])

export const router = createRouter({ routeTree })

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}
